import { styled } from '@mui/material/styles'

export const LabelContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 2px;
`

export const PriorityStatusDot = styled('div')`
  border-radius: 50%;
  width: 13px;
  height: 13px;
  ${({ $color }: { $color?: string }) => ($color ? `background-color: ${$color};` : '')};
  margin-right: 6px;
`
